import moment from 'moment';

import { setError, setSuccessMessage } from '../App/ErrorsActions';
import customFieldsUtils from '../../util/customFieldsUtils';
import downloadFile from '../../util/download';
import { trackDashboardExport } from '../../util/mixpanel';
import CalculationsWorker from '../../services/worker';
import ValuesService from '../../services/values.service';

export const LOADING = 'EXPORTING_LOADING';
export const SUCCESS = 'EXPORTING_SUCCESS';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success() {
  return {
    type: SUCCESS
  };
}

export function exportCsv(chart) {
  return async (dispatch, getState) => {
    dispatch(setSuccessMessage('Exporting CSV file'));

    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { user } = getState().auth;
    const filters = getState().filters;
    const { allCustomFields, dates } = filters;
    const chartFilters = chart ? filters[chart] : filters;

    const valueService = new ValuesService(selected, data);
    const lists = valueService.GetDefaultFilterLists();

    const customFields = chart ?
      customFieldsUtils.getSelected(allCustomFields, chartFilters) :
      customFieldsUtils.getAll(allCustomFields, filters);

    const exportWipCards = !chart || ['cfd', 'cta'].includes(chart);
    const exportDoneCards = !chart || ['cfd', 'ctsp', 'ctb', 'cth', 'trc', 'th', 'fe', 'ddp', 'mc', 'mct'].includes(chart);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, undefined, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableUnmappedListsActivities: user.config.enableUnmappedListsActivities,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });

    try {
      const data = await worker.ExportCsv({
        lists: chartFilters.selectedLists || _.map(lists.all, l => l.value),
        labels: chartFilters.selectedLabels || _.map(filters.allLabels, l => l.value),
        members: chartFilters.selectedMembers || _.map(filters.allMembers, m => m.value),
        customFields,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        dateFormat: filters.dateFormat,
        timePrecision: filters.timePrecision,
        selectedDate: chartFilters.selectedDate,
        dueDateTasks: chartFilters.dueDateTasks,
        timeUnit: chartFilters.timeUnit,
        exportCsvChart: chart,
        exportDoneCards,
        exportWipCards,
        excludeWeekendOpts: {
          type: filters.excludeWeekends,
          workStart: filters.workStart,
          workEnd: filters.workEnd,
          holidays: filters.holidays
        }
      });

      const filename = `csv_${
        chart ? chart : ''
      }_${
        moment(dates.startDate).format('YYYY-M-D')
      }_${
        moment(dates.endDate).format('YYYY-M-D')
      }.csv`;
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      downloadFile(url, filename);
      
      trackDashboardExport('csv');

      dispatch(success());
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
